import React, { useMemo, useState } from "react";
import LayoutContent from "../../LayoutContent";
import Header from "../../Header/Header";
import Breadcrumb from "../../Header/Breadcrumb";
import HeaderButton from "../../Header/HeaderButton";
import IconDebug from "../../../Icons/TopCommandPanel/Debug";
import ToolsNavSubMenu from "../ToolsNavSubMenu";
import StorageListGroup from "./StorageListGroup";
import { EModuleType } from "../../../Model/EModuleType";
import './StoreAndRetrieve.css'
import { HotelConfig } from "../../../Model/StorageConfig";
import { useTypedSelector } from "../../../redux/reducers/RootReducer";
import { getStorageConfig } from "../../../redux/reducers/StorageConfigReducer";
import { getModulesByType } from "../../../redux/reducers/ModuleReducer";
import RadioButton from "../../Buttons/RadioButton";
import MtiButton from "../../Buttons/MtiButton";
import StorageApi from "../../../api/StorageApi";
import ToolsApi from "../../../api/ToolsApi";
import { EAutoCalibrationResult } from "../../../Model/EAutoCalibrationResult";

export default function StoreAndRetrieve() {
  const [isPsrBusy, setIsPsrBusy] = useState(false);
  const [selectedStorageHotelIndex, setSelectedStorageHotelIndex] =
    useState(0);
  const [selectedSlot, setSelectedSlot] = useState(0)
  const [storageModuleType, setStorageModuleType] = useState<EModuleType>(EModuleType.LOADPORT)
  const [imagerId, setImagerId] = useState<string>("");

  const storageModule = useTypedSelector(
      (state) => getModulesByType(state)[storageModuleType][0]
    );
  const storageConfig = useTypedSelector((state) =>
    getStorageConfig(state, storageModule.identifier)
  );

  const disabledButtons = useMemo(() => isPsrBusy === true, [isPsrBusy]);


  const getSlots = (hotelConfig: HotelConfig) => {
    let slots = [];
    let disabledSlotsList: number[] | null =
      hotelConfig?.disabledSlots == null
        ? null
        : hotelConfig.disabledSlots?.split(",").map(Number);
    if (hotelConfig !== undefined) {
      for (let i: number = 0; i < hotelConfig.capacity; i++) {
        let slotIndex: number = i + 1;
        slots.push({
          id: i,
          name: `${hotelConfig.footprint}-${hotelConfig.number}-slot-${i}`,
          display: `Slot ${slotIndex}`,
          disabled: disabledSlotsList?.includes(slotIndex),
        });
      }
    }
    return slots;
  };

  const onClickScanModule = () => {
    setIsPsrBusy(true);
    StorageApi.scanModule(storageModule.identifier) 
  };

  const onClickScanHotel = () => {
    setIsPsrBusy(true);
    StorageApi.scanHotel(
      storageModule.identifier,
      storageConfig.hotels[selectedStorageHotelIndex].number
    );
  };

  const onClickRetrieve = () => {
    setIsPsrBusy(true);
    ToolsApi.retrievePlate(
      storageModule.identifier,
      storageConfig.hotels[selectedStorageHotelIndex].number,
      selectedSlot + 1,
      EAutoCalibrationResult.CurrentAutoCalibration
    );
  };

  const onClickStore = () => {
    setIsPsrBusy(true);
    ToolsApi.storePlate(
      storageModule.identifier,
      storageConfig.hotels[selectedStorageHotelIndex].number,
      selectedSlot + 1,
      EAutoCalibrationResult.CurrentAutoCalibration
    );
  };

  const onClickScan = () => {
    setIsPsrBusy(true);
    StorageApi.scanSlot(
      storageModule.identifier,
      storageConfig.hotels[selectedStorageHotelIndex].number,
      selectedSlot + 1
    );
  };

  const onClickPlateBump = () => {
    setIsPsrBusy(true); 
    ToolsApi.imagerPlateBump(storageModule.identifier)
  }

  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
          <Breadcrumb
            items={[
              {
                title: "Store and Retrieve",
                to: "/tools/store-and-retrieve",
                disabled: false,
              },
            ]}
          />
          <Header.RightSide>
            <HeaderButton
              id={"DEBUG_PAGE"}
              label="Debug"
              icon={<IconDebug />}
              onClick={(id) => {
                window.open("/debug", "debugpage");
              }}
            />
          </Header.RightSide>
        </Header>
      </LayoutContent.Header>
      <LayoutContent.SubMenu>
        <ToolsNavSubMenu />
      </LayoutContent.SubMenu>
      <LayoutContent.Content style={{ paddingTop: 0 }}>
        <div
          style={{
            display: "flex",
            height: "88%",
          }}
        >
          <StorageListGroup
            moduleType={storageModuleType}
            isPsrBusy={isPsrBusy}
            setIsPsrBusy={setIsPsrBusy}
            style={{
              width: "100%",
              border: "1px solid #9E9E9E",
              marginTop: "10px",
              marginLeft: "10px",
              height: "100%",
              overflowY: 'auto',
              overflowX: 'hidden'
            }}
            selectedHotelIndex={selectedStorageHotelIndex}
            setSelectedHotelIndex={(index, moduleType) => {
              setSelectedStorageHotelIndex(index);
              setStorageModuleType(moduleType)
            }}
            setImagerId={setImagerId}
          />
          <div className="slot-wrapper">
            <div className="title">Slot</div>
            <div className="radio-wrapper">
              {getSlots(storageConfig?.hotels[selectedStorageHotelIndex]).map((slot, i) => (
                <RadioButton 
                  id={slot.name + "-" + slot.id}
                  name={slot.name}
                  onChange={() => setSelectedSlot(i)}
                  checked={selectedSlot === i}
                  label={slot.display}
                  color="alternate"
                  style={{fontSize: '14px'}}
                />
              ))}
            </div>
          </div>
          {/* <StorageListGroup
            title="Storage"
            storageModuleType={EModuleType.CHAMBER}
            isPsrBusy={isPsrBusy}
            setIsPsrBusy={setIsPsrBusy}
            style={{
              height: "100%",
              width: "66.16%",
            }}
            selectedHotelIndex={selectedStorageHotelIndex}
            setSelectedHotelIndex={(index) => {
              setSelectedStorageHotelIndex(-1);
            }}
          /> */}
        </div>
        <div className="buttons-wrapper">
          <div className="buttons-container">
            <MtiButton
              variant="primary"
              colorVariant="black"
              disabled={disabledButtons}
              onClick={onClickScanModule}
            >
              {"SCAN LOAD PORT "}
            </MtiButton>
            <MtiButton
              variant="primary"
              colorVariant="black"
              disabled={disabledButtons}
              onClick={onClickScanModule}
            >
              {"SCAN STORAGE "}
            </MtiButton>
          </div>
          <div className="buttons-container">
            <MtiButton
              variant="primary"
              colorVariant="black"
              disabled={disabledButtons}
              onClick={onClickStore}
            >
              STORE
            </MtiButton>
            <MtiButton
              variant="primary"
              colorVariant="black"
              disabled={disabledButtons}
              onClick={onClickRetrieve}
            >
              RETRIEVE
            </MtiButton>
            {storageModuleType === EModuleType.IMAGER ? (
              <MtiButton
              variant="primary"
              colorVariant="black"
              disabled={disabledButtons}
              onClick={onClickPlateBump}
            >
              PLATE BUMP
            </MtiButton> 
            ): (
              <>
              <MtiButton
                variant="primary"
                colorVariant="black"
                disabled={disabledButtons}
                onClick={onClickScan}
              >
                SCAN SLOT
              </MtiButton>

              <MtiButton
                variant="primary"
                colorVariant="black"
                disabled={disabledButtons || selectedStorageHotelIndex < 0}
                onClick={onClickScanHotel}
              >
                SCAN ALL SLOT
              </MtiButton>
              
              </>
            )}
          </div>
        </div>
      </LayoutContent.Content>
    </LayoutContent>
  );
}
